import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import * as Luxon from 'luxon';
import React from 'react';

export default function BloodGlocoseDialogInsulinTable(props) {
  const {
    data,
  } = props;

  const {
    bldsugr_graph_list = [],
    // bld_sugr_time,
    // bld_sugr_value,
    // max_bld_sugr_yn,
    postprand2h_max_bldsugr_time,
    postprand2h_max_bldsugr_time_zone_tp_cd,
    bldsugr_before_meal,
    postprand2h_max_bldsugr,
    postprand2h_bldsugr,
    postprand2h_bldsugr_rise_w,
    postprand2h_bldsugr_tp,
    postprand_abnrml_bldsugr_min,
    main_food_list = [],
    // intaken_time,
    // main_food_nm,
    // main_food_cal,
    total_intaken_cal,
    carbo_rate,
    protein_rate,
    fat_rate,
    postprand_active_time,
    postprand_step_cnt,
    postprand_burn_cal,
    bolus_cnt,
    bolus_amt,
    bolus_time_list,
  } = data;

  const time = React.useMemo(() => {
    if (bolus_time_list) {
      return bolus_time_list.map(({ bolus_time, bolus_amt }) => T('{0} ({1}U)', Luxon.DateTime.fromFormat(bolus_time, 'HHmm').toFormat('HH:mm'), bolus_amt)).join(', ');
    } else {
      return '';
    }
  }, [bolus_time_list]);

  return (
    <table>
      <tbody>
        <tr>
          <th>
            <div>
              {T('볼루스 투여기록')}
            </div>
          </th>
          <td>
            <div>
              {T('{0} 회', bolus_cnt)}
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <div>
              {T('볼루스 총 투여량')}
            </div>
          </th>
          <td>
            <div>
              {T('{0} U', bolus_amt)}
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <div>
              {T('볼루스 투여시간')}
            </div>
          </th>
          <td>
            <div>
              {time}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
